import { marked } from "marked";
import DOMPurify from "dompurify";
import { useEffect, useRef } from "react";

const MarkdownContent = ({ content }) => {
  const containerRef = useRef(null);

  const html = DOMPurify.sanitize(marked(content));

  useEffect(() => {
    if (containerRef.current) {
      const links = containerRef.current.querySelectorAll("a");
      links.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          const url = link.getAttribute("href");
          if (url) {
            window.open(url, "_blank");
          }
        });
      });

      // Cleanup function
      return () => {
        links.forEach((link) => {
          link.removeEventListener("click", () => {});
        });
      };
    }
  }, [html]);

  return (
    <div
      ref={containerRef}
      className="markdown-body"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default MarkdownContent;
